import React from 'react'
import {Icon} from '@chakra-ui/react'

const SummaryCheckIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" {...props}>
            <path
                d="M7.00098 0.416992C10.6366 0.417149 13.5848 3.36437 13.585 7C13.5848 10.6356 10.6366 13.5838 7.00098 13.584C3.36535 13.5838 0.418125 10.6356 0.417969 7C0.418144 3.36438 3.36536 0.417168 7.00098 0.416992ZM9.28125 5.30273C8.98839 5.01003 8.51356 5.01003 8.2207 5.30273L6.41699 7.10547L5.78125 6.46973C5.48839 6.17703 5.01356 6.17703 4.7207 6.46973C4.42802 6.76258 4.42801 7.23742 4.7207 7.53027L5.8877 8.69629C6.02835 8.83694 6.21906 8.91602 6.41797 8.91602C6.61676 8.91593 6.80767 8.83686 6.94824 8.69629L9.28125 6.36328C9.574 6.07038 9.57409 5.59558 9.28125 5.30273Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SummaryCheckIcon
